import { combineReducers } from 'redux';

export function error(state = null, action) {
  switch (action.type) {
    case 'CREDIT_NOTE_LIST_ERROR':
      return action.error;

    case 'CREDIT_NOTE_LIST_RESET':
      return null;

    default:
      return state;
  }
}

export function loading(state = false, action) {
  switch (action.type) {
    case 'CREDIT_NOTE_LIST_LOADING':
      return action.loading;

    case 'CREDIT_NOTE_LIST_RESET':
      return false;

    default:
      return state;
  }
}

export function data(state = {}, action) {
  switch (action.type) {
    case 'CREDIT_NOTE_LIST_SUCCESS':
      return action.data;

    case 'CREDIT_NOTE_LIST_RESET':
      return {};

    default:
      return state;
  }
}

export default combineReducers({
  error, loading, data,
});
